module.exports = __webpack_public_path__ + "74b8dd0aa53ea6acf50309490cc98961.jpg";